import { render, staticRenderFns } from "./ExaminationRecords.vue?vue&type=template&id=11ca27ec&scoped=true&"
import script from "./ExaminationRecords.vue?vue&type=script&lang=js&"
export * from "./ExaminationRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ca27ec",
  null
  
)

export default component.exports